/**
 * Coverax Global Menu – Rendert Inhalte aus coverax-global-menu.json
 */
(function () {
    'use strict';

    const STAT_ICONS = [
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>',
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>',
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>',
    ];

    const EXTERNAL_ICON =
        '<span class="gmenu-card__external-icon" aria-hidden="true">' +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
        '<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>' +
        '<polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/>' +
        '</svg></span>';

    function esc(str) {
        return String(str ?? '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    function safeUrl(url) {
        const value = String(url ?? '').trim();
        if (!value) return '#';
        // Nur relative Pfade, Anker sowie http(s)/mailto/tel zulassen (kein javascript:/data:)
        return /^(https?:|mailto:|tel:|\/|#|\?)/i.test(value) ? value : '#';
    }

    function isExternal(url) {
        return /^https?:\/\//i.test(url || '');
    }

    function imageUrl(filename, assetRoot) {
        if (!filename) return '';
        if (/^https?:\/\//i.test(filename) || filename.startsWith('//')) return filename;
        const clean = String(filename).replace(/^\/+/, '');
        return assetRoot + clean;
    }

    function cardBodyContent(title, subtitle, stats) {
        let html =
            '<div class="gmenu-card__body-content">' +
            '<div class="gmenu-card__head"><p class="gmenu-card__title">' + esc(title) + '</p></div>';

        if (subtitle) {
            html += '<p class="gmenu-card__subtitle">' + esc(subtitle) + '</p>';
        }

        if (stats && stats.length) {
            html += '<hr class="gmenu-card__divider"><div class="gmenu-card__stats">';
            stats.slice(0, 3).forEach((stat, i) => {
                html +=
                    '<div class="gmenu-card__stat">' +
                    '<span class="gmenu-card__stat-icon">' + STAT_ICONS[i % 3] + '</span>' +
                    '<span class="gmenu-card__stat-text">' + esc(stat.label) + ': ' + esc(stat.value) + '</span>' +
                    '</div>';
            });
            html += '</div>';
        }

        html += '</div>';
        return html;
    }

    function renderBrandCard(card, assetRoot) {
        const title = card.title || '';
        const url = safeUrl(card.url);
        const subtitle = card.subtitle || title;
        const external = isExternal(url);
        const img = imageUrl(card.image, assetRoot);

        let html =
            '<a href="' + esc(url) + '" class="gmenu-card gmenu-card--brand' + (external ? ' gmenu-card--external' : '') + '" role="listitem" data-gmenu-close-link title="' + esc(title) + '"';

        if (external) {
            html += ' target="_blank" rel="noopener noreferrer" aria-label="' + esc(title) + ' (öffnet in neuem Tab)"';
        }

        html += '>';

        if (external) html += EXTERNAL_ICON;

        html += '<div class="gmenu-card__logo-wrap">';
        if (img) {
            html += '<img class="gmenu-card__logo" data-gmenu-src="' + esc(img) + '" alt="' + esc(title) + '" title="' + esc(title) + '" loading="lazy">';
        }
        if (card.badge) {
            html += '<span class="gmenu-card__badge">' + esc(card.badge) + '</span>';
        }
        html += '</div><div class="gmenu-card__brand-body">' + cardBodyContent(title, subtitle, []) + '</div></a>';

        return html;
    }

    function phGradient(hue) {
        return (
            'linear-gradient(160deg, hsl(' +
            hue +
            ', 28%, 38%) 0%, hsl(' +
            hue +
            ', 22%, 18%) 100%)'
        );
    }

    function renderCarouselCard(card, assetRoot, cardIndex) {
        const title = card.title || '';
        const url = safeUrl(card.url);
        const subtitle = card.subtitle || title;
        const img = imageUrl(card.image, assetRoot);
        const phHue = (cardIndex * 47 + 120) % 360;
        const gradient = phGradient(phHue);

        let html =
            '<a href="' + esc(url) + '" class="gmenu-card" role="listitem" data-gmenu-close-link title="' + esc(title) + '">';

        if (img) {
            html += '<div class="gmenu-card__media">';
            html += '<img data-gmenu-src="' + esc(img) + '" alt="' + esc(title) + '" title="' + esc(title) + '" loading="lazy">';
        } else {
            html +=
                '<div class="gmenu-card__media gmenu-card__media--placeholder" style="--ph-hue:' +
                phHue +
                ';background:' +
                gradient +
                '">';
            html +=
                '<div class="gmenu-card__ph" style="--ph-hue:' +
                phHue +
                ';background:' +
                gradient +
                '" aria-hidden="true"></div>';
        }

        if (card.badge) {
            html += '<span class="gmenu-card__badge">' + esc(card.badge) + '</span>';
        }

        html +=
            '</div><div class="gmenu-card__body">' +
            '<div class="gmenu-card__body-blur" aria-hidden="true"></div>' +
            cardBodyContent(title, subtitle, card.stats || []) +
            '</div></a>';

        return html;
    }

    function renderSection(section, assetRoot) {
        const layout = section.layout || 'carousel';
        const isGrid = layout === 'grid';
        const hasHead = section.title || section.show_all;

        let html = '<section class="gmenu__section' + (isGrid ? ' gmenu__section--grid' : '') + '">';

        if (hasHead) {
            html += '<div class="gmenu__section-top">';
            if (section.title) {
                html += '<p class="gmenu__section-title">' + esc(section.title) + '</p>';
            }
            if (section.show_all) {
                html +=
                    '<a href="' + esc(safeUrl(section.show_all.url)) + '" class="gmenu__section-more" title="' + esc(section.show_all.label) + '" data-gmenu-close-link>' +
                    esc(section.show_all.label) +
                    '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>';
            }
            html += '</div>';
        }

        html += '<div class="gmenu__track-wrap">';

        if (isGrid) {
            html += '<div class="gmenu__card-grid" role="list">';
            (section.cards || []).forEach((card) => {
                html += renderBrandCard(card, assetRoot);
            });
            html += '</div>';
        } else {
            html += '<div class="gmenu__track" tabindex="0" role="list">';
            (section.cards || []).forEach((card, i) => {
                html += renderCarouselCard(card, assetRoot, i);
            });
            html += '</div>';
            html +=
                '<button type="button" class="gmenu__track-next" aria-label="Weiter scrollen" data-gmenu-scroll="next" hidden>' +
                '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg></button>';
        }

        html += '</div></section>';
        return html;
    }

    function renderView(tab, isActive, assetRoot) {
        const viewTitle = tab.view_title || tab.label;

        let html =
            '<div class="gmenu__view' + (isActive ? ' is-active' : '') + '" id="gmenu-panel-' + esc(tab.id) + '" role="tabpanel" aria-labelledby="gmenu-tab-' + esc(tab.id) + '"' + (isActive ? '' : ' hidden') + '>' +
            '<div class="gmenu__view-head"><p class="gmenu__view-title">' + esc(viewTitle) + '</p>';

        if (tab.sublinks && tab.sublinks.length) {
            html += '<div class="gmenu__chips" aria-label="Unterpunkte">';
            tab.sublinks.forEach((link) => {
                html += '<a href="' + esc(safeUrl(link.url)) + '" class="gmenu__chip" title="' + esc(link.label) + '" data-gmenu-close-link>' + esc(link.label) + '</a>';
            });
            html += '</div>';
        }

        html += '</div><div class="gmenu__sections">';
        (tab.sections || []).forEach((section) => {
            html += renderSection(section, assetRoot);
        });
        html += '</div></div>';

        return html;
    }

    function renderMenu(config, data) {
        const tabs = data.tabs || [];
        const defaultTab = config.defaultTab || data.default_tab || tabs[0]?.id || '';
        const assetRoot = config.assetRoot || '';
        const unifiedTrack = document.getElementById('gmenu-unified-track');
        const sidebarNav = document.getElementById('gmenu-sidebar-nav');
        const mainViews = document.getElementById('gmenu-main-views');
        const menu = document.getElementById('global-menu');

        if (!sidebarNav || !mainViews || !menu) return defaultTab;

        let sidebarHtml = '';
        let viewsHtml = '';
        let unifiedHtml = '';

        tabs.forEach((tab) => {
            const isActive = tab.id === defaultTab;

            unifiedHtml +=
                '<button type="button" class="gmenu__unified-tab" data-gmenu-unified data-gmenu-mode="global" data-gmenu-tab="' + esc(tab.id) + '" role="tab" aria-selected="false" aria-controls="gmenu-panel-' + esc(tab.id) + '">' +
                esc(tab.label) +
                '</button>';

            sidebarHtml +=
                '<li role="presentation">' +
                '<button type="button" class="gmenu__nav-btn' + (isActive ? ' is-active' : '') + '" id="gmenu-tab-' + esc(tab.id) + '" role="tab" aria-selected="' + (isActive ? 'true' : 'false') + '" aria-controls="gmenu-panel-' + esc(tab.id) + '" data-gmenu-tab="' + esc(tab.id) + '">' +
                '<span class="gmenu__nav-btn-text">' + esc(tab.label) + '</span>' +
                '<svg class="gmenu__nav-btn-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>' +
                '</button></li>';

            viewsHtml += renderView(tab, isActive, assetRoot);
        });

        if (unifiedTrack) unifiedTrack.insertAdjacentHTML('beforeend', unifiedHtml);
        sidebarNav.innerHTML = sidebarHtml;
        mainViews.innerHTML = viewsHtml;
        menu.dataset.gmenuDefaultTab = defaultTab;
        menu.classList.add('gmenu--ready');
        if (window.coveraxGmenuHydrate && window.__coveraxGmenuImgsReady) window.coveraxGmenuHydrate();

        return defaultTab;
    }

    window.coveraxGmenuRender = function () {
        const menu = document.getElementById('global-menu');
        if (menu?.dataset.gmenuSource === 'liquid') {
            menu.classList.add('gmenu--ready');
            return Promise.resolve(menu.dataset.gmenuDefaultTab || '');
        }

        const config = window.coveraxGmenuConfig;
        if (!config || !config.jsonUrl) {
            return Promise.reject(new Error('coveraxGmenuConfig missing'));
        }

        return fetch(config.jsonUrl)
            .then((res) => {
                if (!res.ok) throw new Error('JSON fetch failed: ' + res.status);
                return res.json();
            })
            .then((data) => renderMenu(config, data));
    };
})();
